import React from "react";
import Button from "components/button/Button";
import BranchData from "./variables/branchData";
import BranchCard from "./components/BranchCard";
import { useNavigate } from "react-router-dom";
import { IBranch } from "./types/branch.interface";
import { TiPlus } from "react-icons/ti";
import { getBranches } from "api/BranchAPI";
import { toast } from "react-hot-toast";
import { Spinner } from "@chakra-ui/react";

const Branches = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [branches, setBranches] = React.useState<IBranch[]>([]);

  const getBranchesData = () => {
    const promise = getBranches();
    promise
      .then((res) => {
        if (res.status === 200) {
          setBranches(res.data?.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(
          err?.response?.data?.message || "Gagal mengambil data toko!"
        );
      });
  };

  React.useEffect(() => {
    getBranchesData();
  }, []);

  return (
    <div className="mt-3 h-full">
      <div className="h-fit w-full">
        {/* Recenlty Added setion */}
        <div className="mb-5 mt-5 flex items-center justify-between px-[26px]">
          <h4 className="text-2xl font-bold text-navy-700 dark:text-white">
            Daftar Toko
          </h4>
          <Button
            size="fit"
            variant="primary"
            children={
              <div className="flex items-center gap-1">
                <TiPlus /> Toko
              </div>
            }
            onClick={() => {
              navigate("/admin/branches/add");
            }}
          />
        </div>

        {/* NFTs trending card */}
        {!isLoading ? (
          branches.length > 0 ? (
            <div className="z-20 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3">
              {branches.map((branch, idx) => (
                <div key={idx}>
                  <BranchCard
                    id={branch.id}
                    slug={branch.slug}
                    name={branch.name}
                    open_time={branch.open_at}
                    address={branch.address}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="flex h-80 items-center justify-center">
              <p className="text-lg font-medium text-gray-600 dark:text-gray-400">
                Belum ada toko cabang yang ditambahkan
              </p>
            </div>
          )
        ) : (
          <div className="flex h-80 w-full flex-col items-center justify-center">
            <Spinner size="xl" className="text-brand-400" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Branches;
